import { render, staticRenderFns } from "./BlogsModule.vue?vue&type=template&id=c0b3b89e&scoped=true&"
import script from "./BlogsModule.vue?vue&type=script&lang=js&"
export * from "./BlogsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b3b89e",
  null
  
)

export default component.exports